import { WorkplaceResponse } from '../@types/workplaceData';

const WORKER_TRANSPORT_API_URL = (window as any).WORKER_TRANSPORT_API_URL;

export const getWorkplaces = async (
    token: string,
    onResponseError: (response: Response) => void,
    onError: (message: string) => void
) => {
    try {
        const response = await fetch(`${WORKER_TRANSPORT_API_URL}/v1/workplace/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            mode: 'cors',
        });
        if (response.ok) {
            const workplaceList: WorkplaceResponse[] = await response.json();

            const workplaceMenuItems = [];
            for (const workplace of workplaceList) {
                workplaceMenuItems.push({ value: workplace.queryName, label: workplace.name });
            }
            return workplaceMenuItems;
        } else {
            onResponseError(response);
            return;
        }
    } catch (error: any) {
        onError('Hiba a szerver elérésében! ' + error.message);
    }
}

export const getEmployeeDevicesByCompany = async (
    workplace: string,
    token: string,
    onResponseError: (response: Response) => void,
    onError: (message: string) => void
) => {
    try {
        const url = new URL(`${WORKER_TRANSPORT_API_URL}/v1/app-user/appusers-by-company`)
        if (workplace !== '') {
            url.searchParams.append('workplace', workplace)
        }
        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            mode: 'cors',
        });
        if (response.ok) {
            return await response.json();
        } else {
            onResponseError(response);
            return;
        }
    } catch (error: any) {
        onError('Hiba a szerver elérésében! ' + error.message);
    }
};